import { render } from "./AiAlanYardimci.vue?vue&type=template&id=74f59f56&scoped=true"
import script from "./AiAlanYardimci.vue?vue&type=script&lang=js"
export * from "./AiAlanYardimci.vue?vue&type=script&lang=js"

import "./AiAlanYardimci.vue?vue&type=style&index=0&id=74f59f56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f59f56"]])

export default __exports__